var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-circle",
    clipPath: "url(#clip0_1_154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50 87.5C70.5036 87.5 87.125 70.7107 87.125 50C87.125 29.2893 70.5036 12.5 50 12.5C29.4964 12.5 12.875 29.2893 12.875 50C12.875 70.7107 29.4964 87.5 50 87.5Z",
    stroke: "url(#paint0_linear_1_154)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5 50L50 66.6667",
    stroke: "url(#paint1_linear_1_154)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50 33.3334V66.6667",
    stroke: "url(#paint2_linear_1_154)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.5 50L50 66.6667",
    stroke: "url(#paint3_linear_1_154)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_154",
    x1: 50,
    y1: 12.5,
    x2: 50,
    y2: 87.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF007C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E66FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_154",
    x1: 41.75,
    y1: 50,
    x2: 41.75,
    y2: 66.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF007C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E66FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_154",
    x1: 50.5,
    y1: 33.3334,
    x2: 50.5,
    y2: 66.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF007C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E66FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_154",
    x1: 58.25,
    y1: 50,
    x2: 58.25,
    y2: 66.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF007C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E66FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.29fbd0d33c96d42487b9b7dd9b74e974.svg";
export { ForwardRef as ReactComponent };